import { ISearchable } from 'src/app/common/contracts/components/searchable';

export class TemplateTagItem implements ISearchable {
  public _id: string;
  constructor() {}
  get displayText(): string {
    return this._id;
  }
}
